<h2 class="p-6 pb-4">
  {{ (isEdit() ? "prescription.action.editFreeForm" : "prescription.action.addFreeForm") | translate }}
</h2>
<div class="overflow-y-auto px-6 py-0">
  @if (!loading()) {
    <div
      class="flex flex-col rounded-lg border-2 border-transparent p-3 shadow-inner"
      [formGroup]="form"
    >
      <mat-form-field class="mt-2 w-full">
        <mat-label>{{ "prescription.label.type" | translate }}</mat-label>
        <mat-select formControlName="type">
          @for (type of prescriptionTypes; track type) {
            <mat-option [value]="type">{{ "medicalServices.prescriptionTypes." + type | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>{{ "prescription.label.name" | translate }}</mat-label>
        <input
          matInput
          type="text"
          formControlName="name"
          [matAutocomplete]="nameAutocomplete"
          [placeholder]="'prescription.label.name' | translate"
        />
        <mat-autocomplete
          #nameAutocomplete="matAutocomplete"
          (optionSelected)="selectServiceOption($event.option.value)"
        >
          @for (option of servicesOptions(); track option.code) {
            <mat-option [value]="option">{{ option.nameUa }} ({{ option.code }})</mat-option>
          }
        </mat-autocomplete>
        @if (nameSearchEnabled()) {
          <mat-hint>{{ "prescription.message.nameSearchHint" | translate }}</mat-hint>
        }
      </mat-form-field>

      @if (freeForm() || isServiceType()) {
        <div class="flex w-full gap-4">
          @if (freeForm()) {
            <mat-form-field class="w-full">
              <mat-label>{{ "prescription.label.code" | translate }}</mat-label>
              <input
                matInput
                type="text"
                formControlName="code"
              />
            </mat-form-field>
          }
          @if (isServiceType()) {
            <mat-form-field class="w-full">
              <mat-label>{{ "prescription.label.quantity" | translate }}</mat-label>
              <input
                matInput
                type="number"
                formControlName="quantity"
                [min]="1"
              />
            </mat-form-field>
          }
        </div>
      }

      <shared-datepicker
        type="date"
        class="w-full"
        containerClass="flex flex-col gap-1 sm:flex-row sm:gap-3"
        labelKey="prescription.label.startDate"
        formControlName="startDate"
      />

      <mat-form-field class="w-full">
        <mat-label>{{ "prescription.label.franchisePercent" | translate }}</mat-label>
        <input
          matInput
          type="number"
          formControlName="franchise"
          [max]="100"
          [min]="0"
        />
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>{{ "prescription.label.reservedPrice" | translate }}</mat-label>
        <input
          matInput
          formControlName="reservedPrice"
        />
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>{{ "prescription.label.categories" | translate }}</mat-label>
        <mat-select
          formControlName="categories"
          [multiple]="true"
          [compareWith]="compareCategories"
        >
          @for (category of categoryOptions(); track category.categoryCode) {
            <mat-option [value]="category">{{ category.categoryName }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>{{ "prescription.label.guaranteeStatus" | translate }}</mat-label>
        <mat-select formControlName="guaranteeStatus">
          @for (status of guaranteeStatusOptions; track status) {
            <mat-option [value]="status">{{ "statuses.guarantationStatuses." + status | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (statusChanged()) {
        @if (form.controls.guaranteeStatus.value === guaranteeStatus.Guaranteed) {
          <mat-form-field class="w-full">
            <mat-label>{{ "prescription.label.editReason" | translate }}</mat-label>
            <input
              matInput
              type="text"
              formControlName="statusReason"
              [matAutocomplete]="editReasonAutocomplete"
            />
            <mat-autocomplete #editReasonAutocomplete="matAutocomplete">
              @for (reason of filteredEditReasons(); track reason) {
                <mat-option [value]="reason">{{ reason }}</mat-option>
              }
            </mat-autocomplete>
            @if (form.controls.statusReason.value) {
              <button
                matSuffix
                mat-icon-button
                type="button"
                aria-label="Clear"
                (click)="clearStatusReason()"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
        } @else {
          <mat-form-field class="w-full">
            <mat-label>{{ "prescription.label.declineReason" | translate }}</mat-label>
            <input
              matInput
              type="text"
              formControlName="statusReason"
              [matAutocomplete]="declineReasonAutocomplete"
            />
            <mat-autocomplete #declineReasonAutocomplete="matAutocomplete">
              @for (reason of filteredDeclineReasons(); track reason) {
                <mat-option [value]="reason">{{ reason }}</mat-option>
              }
            </mat-autocomplete>
            @if (form.controls.statusReason.value) {
              <button
                matSuffix
                mat-icon-button
                type="button"
                aria-label="Clear"
                (click)="clearStatusReason()"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
        }
      }

      <div class="mb-4 flex items-center gap-4">
        <mat-checkbox formControlName="considerPaid">{{ "prescription.label.considerPaid" | translate }}</mat-checkbox>
      </div>
    </div>
  } @else {
    <div class="flex items-center justify-center">
      <shared-loader></shared-loader>
    </div>
  }
</div>

<div class="flex justify-end gap-4 p-6">
  <button
    class="btn btn-secondary"
    [type]="'button'"
    [disabled]="loading()"
    (click)="close()"
  >
    {{ "general.action.cancel" | translate }}
  </button>
  <button
    class="btn btn-primary"
    [type]="'submit'"
    [disabled]="loading()"
    (click)="submit()"
  >
    {{ "general.action.save" | translate }}
  </button>
</div>
